import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output
} from '@angular/core';
import { roundToStep } from '@k2/common/helpers';
import { isEmpty } from 'ramda';

@Component({
    selector: 'number-input',
    templateUrl: 'number-input.component.html',
    styleUrls: ['number-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NumberInputComponent implements OnChanges {
  @Input() value: number;
  @Input() step = 1;
  @Input() min = 0;
  @Input() max = 999999;
  @Input() disabled = false;
  @Output() valueChange = new EventEmitter();
  innerValue: number;
  private accepted = true;

  ngOnChanges(): void {
    if (this.accepted) {
      this.innerValue = this.value;
    }
  }

  handleChange = (value: number) => {
    if (this.innerValue === value) return;
    this.innerValue = value;

    const normalized = this.normalize(value);
    this.accepted = false;
    this.value = normalized;
    this.valueChange.emit(normalized);
  };

  private normalize = (value: number) => {
    if (value == null || isEmpty(value)) return 0;
    if (value < this.min) return this.min;
    if (value > this.max) return this.max;

    return roundToStep(value, this.step);
  };

  handleBlur = () => {
    this.innerValue = this.value;
    this.accepted = true;
  };
}
